import { render, staticRenderFns } from "./EndCourseModal.vue?vue&type=template&id=e15cb47a&"
import script from "./EndCourseModal.vue?vue&type=script&lang=ts&"
export * from "./EndCourseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports